export default __webpack_public_path__ + "3e990863c139714298492bb4a141c15f.png";